import { render, staticRenderFns } from "./DietaryImprovement.vue?vue&type=template&id=391b4faa&scoped=true"
import script from "./DietaryImprovement.vue?vue&type=script&lang=js"
export * from "./DietaryImprovement.vue?vue&type=script&lang=js"
import style0 from "./DietaryImprovement.vue?vue&type=style&index=0&id=391b4faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b4faa",
  null
  
)

export default component.exports